// import React, { useState } from 'react';
// import { toast } from 'react-toastify';

// const Members = () => {
//     const [isChecked, setIsChecked] = useState(false);
//     const [isCustomAmount, setIsCustomAmount]=useState(false)
//     const [donationType, setDonationType] = useState("");

//     const handleCheckboxChange = (e) => {
//         setIsChecked(e.target.checked);
//     };

//     const handleAddUser = (e) => {
//         e.preventDefault();
//         const name = e.target.name.value;
//         const mobile = e.target.mobile.value;
//         const guardian_name = e.target.guardian_name.value;
//         const age = e.target.age.value;
//         const occupation = e.target.occupation.value;
//         const medium_name = e.target.medium_name.value;
//         const medium_phone = e.target.medium_phone.value;
//         const fixed_village = e.target.fixed_village.value;
//         const fixed_thana = e.target.fixed_thana.value;
//         const fixed_district = e.target.fixed_district.value;
//         const current_village = e.target.current_village.value;
//         const current_thana = e.target.current_thana.value;
//         const current_district = e.target.current_district.value;
//         const donation_type = e.target.donation_type.value;
//         const custom_donation_type = e.target.custom_donation_type.value;
//         const custom_amount = e.target.custom_amount.value;
//         const payment_type = e.target.payment_type.value;
//         const queryData = {
//             name, mobile, guardian_name, age, occupation, medium_name, medium_phone, fixed_village, fixed_thana, fixed_district,
//             current_village, current_thana, current_district, donation_type, custom_donation_type,custom_amount, payment_type
//         }
//         // console.log(queryData);


//         fetch('https://madrumi.thakurgaonexpress.com/members', {
//             method: 'POST',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(queryData)

//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);
//                 e.target.reset();
//                 toast.success("আপনার আজীবন সদস্য ফর্ম পুরন সফল হয়েছে, ধন্যবাদ।")
//             })

//         const token = `92310756091678413369ac9dc34ff7599524a6ea84a77094beb1`;
//         const msg = `জনাব ${name}, আসসালামু আলাইকুম, মাদ্‌রাসা-এ জালালুদ্দীন রূমীর আজীবন দাতা সদস্য হওয়ার জন্য আপনাকে আন্তরিক মুবারকবাদ। প্রয়োজনে যোগাযোগ 01758053022`;
//         // বরাবরের নেয় এ বছরও আগামি ২৭শে ফেব্রুয়ারি ২০২৪ইং তারিখে আমাদের ইসলামি মহাসম্মেলন অনুষ্ঠিত হতে যাচ্ছে ইনশাআল্লাহ। আপনার একান্ত সহযোগিতা কামনা করছি।
//         // const msg = `প্রিয় ${data.name}, আসসালামু আলাইকুম,একতা যুব সমাজের সম্মানিত সদস্য হিসেবে আপনি জেনে অত্যন্ত আনন্দিত হবেন যে, প্রতি বছরের ন্যায় একতা যুব সমাজের উদ্যোগে এ বছরও আগামি ২৭শে ফেব্রুয়ারি ২০২৪ইং তারিখে ইসলামি মহাসম্মেলন অনুষ্ঠিত হতে যাচ্ছে ইনশাআল্লাহ। উক্ত মহাসম্মেলনকে সফলভাবে বাস্তবায়নের লক্ষ্যে আগামিকাল শুক্রবার সন্ধ্যা সাড়ে ৭টায় ফকিরবাড়ি জামে মসজিদে অত্যন্ত গুরুত্বপূর্ণ পরামর্শসভা অনুষ্ঠিত হবে ইনশাআল্লাহ। তাই মাহফিল কামিয়াবির লক্ষ্যে আগামিকালের পরামর্শে আপনাকে উপস্থিত হওয়ার জন্য অনুরুধ করা হলো। প্রয়োজনে-01971909352`;
//         // const msg = `প্রিয় ${data.name}, আসসালামু আলাইকুম একতা যুব সমাজের সম্মানিত সদস্য। আজ রাত ৭ঃ৩০ মিনিটে কাওরাইদ মধ্যপাড়া ফকির বাড়ি জামে মসজিদে মাহফিলের পরামর্শে আপনার উপস্থিতি কামনা করছি,01971909352`;
//         const message = encodeURI(msg)
//         const url = `https://api.greenweb.com.bd/api.php?token=${token}&to=${mobile}&message=${message}`

//         fetch(url)
//             .then(res => res.json())
//             .then(data => {
//                 // console.log(data);
//             })

//     }

//     // const handleCustomAmount = (e) => {
//     //     const isValue = e.target.value;
//     //     setIsCustomAmount(!!isValue);
//     //     if (isValue) {
//     //         setDonationType(""); // Reset the selected donation type
//     //     }
//     // };
//     return (
//         <div className='my-px pt-4'>
//             <div className='leading-5'>
//                 <h1 className='text-2xl  font-bold  inline-block'> মাদ্‌রাসা-এ জালালুদ্দীন রূমী</h1> <br />
//                 <h1 className='text-xl font-bold inline-block'>খানকা চিশতিয়া এমদাদিয়া আশরাফিয়া</h1> <br />
//                 <h1 className='text-lg  font-bold  inline-block'>গুলশান-এ শাহ্‌ আব্দুল মতীন কমপ্লেক্স</h1> <br />
//                 <h1 className='text-md border-b-4 border-accent font-bold  inline-block'>রূমী নগর, বড় জাফরপুর, কলাকোপা, নবাবগঞ্জ, ঢাকা।</h1>
//                 <br />
//                 <p className='text-justify mx-4 mt-4'>  <span className='font-bold'>মাদ্‌রাসা -এ জালালুদ্দীন রূমী এর</span> সার্বিক উন্নতি-অগ্রগতির সঙ্গী হতে আজীবন সদস্য হোন।
//                     {/* <span className='font-bold'> ১৬ই ডিসেম্বর ২০২৪ ইং </span>
//                     সোমবার সকাল ৯.৩০ মিনিটে অনুষ্ঠিত হবে ইনশাল্লাহ। */}
//                 </p>
//             </div>
//             <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>নতুন আজীবন দাতা সদস্য ফর্ম</h1><br />
//             <hr />

//             {/* <p className='text-justify mx-2 font-bold'>বিঃ দ্রঃ- একবারের বেশি রেজিস্টার করার দরকার নেই। </p> */}
//             <div>
//                 <form onSubmit={handleAddUser} className='mt-8 flex justify-center items-center flex-col'>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">মোবাইল নম্বর *</span>
//                         </label>
//                         <input name='mobile' type="number" placeholder="মোবাইল নম্বর" class="input input-bordered w-full max-w-xs" required />
//                     </div>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">আপনার নাম *</span>
//                         </label>
//                         <input name='name' type="text" placeholder="আপনার নাম" class="input input-bordered w-full max-w-xs" required />
//                     </div>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">পিতা/স্বামীর নাম</span>
//                         </label>
//                         <input name='guardian_name' type="text" placeholder="পিতা/স্বামীর নাম" class="input input-bordered w-full max-w-xs" />
//                     </div>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">বয়স</span>
//                         </label>
//                         <input name='age' type="text" placeholder="আপনার বয়স" class="input input-bordered w-full max-w-xs" />
//                     </div>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">পেশা</span>
//                         </label>
//                         <input name='occupation' type="text" placeholder="আপনার পেশা" class="input input-bordered w-full max-w-xs" />
//                     </div>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">আপনি কার মাধ্যমে সদস্য হচ্ছেন? (যদি থাকে)</span>
//                         </label>
//                         <input name='medium_name' type="text" placeholder="মাধ্যমের নাম" class="input input-bordered w-full max-w-xs" />
//                         <input name='medium_phone' type="text" placeholder="মোবাইল নম্বর" class="input input-bordered w-full max-w-xs" />
//                         {/* <textarea name='query' class="textarea textarea-bordered" placeholder="আপনার ঠিকানা লিখুন"></textarea> */}
//                     </div>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">স্থায়ী ঠিকানা</span>
//                         </label>
//                         <input name='fixed_village' type="text" placeholder="গ্রাম/ওয়ার্ড" class="input input-bordered w-full max-w-xs" />
//                         <input name='fixed_thana' type="text" placeholder="থানা" class="input input-bordered w-full max-w-xs" />
//                         <input name='fixed_district' type="text" placeholder="জেলা" class="input input-bordered w-full max-w-xs" />
//                         {/* <textarea name='query' class="textarea textarea-bordered" placeholder="আপনার ঠিকানা লিখুন"></textarea> */}
//                     </div>
//                     <div class="form-control w-80">
//                         <label class="label">
//                             <span class="label-text">বর্তমান ঠিকানা</span>
//                         </label>
//                         <input name='current_village' type="text" placeholder="গ্রাম/ওয়ার্ড" class="input input-bordered w-full max-w-xs" />
//                         <input name='current_thana' type="text" placeholder="থানা" class="input input-bordered w-full max-w-xs" />
//                         <input name='current_district' type="text" placeholder="জেলা" class="input input-bordered w-full max-w-xs" />
//                         {/* <textarea name='query' class="textarea textarea-bordered" placeholder="আপনার ঠিকানা লিখুন"></textarea> */}
//                     </div>
//                     <div className="form-control w-80 text-xs border b-1 border-accent p-2 my-2">
//                         <label className="label">
//                             <span className="label-text">আপনার অনুদানের ধরন নির্বাচন করুন</span>
//                         </label>
//                         {/* <div className="grid grid-cols-2 gap-2">
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={100000} className="radio radio-accent" />
//                                 <span>বার্ষিক এক লক্ষ টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={50000} className="radio radio-accent" />
//                                 <span>বার্ষিক ৫০ হাজার টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={25000} className="radio radio-accent" />
//                                 <span>বার্ষিক ২৫ হাজার টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={15000} className="radio radio-accent" />
//                                 <span>বার্ষিক ১৫ হাজার টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={10000} className="radio radio-accent" />
//                                 <span>বার্ষিক ১০ হাজার টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={5000} className="radio radio-accent" />
//                                 <span>বার্ষিক ৫ হাজার টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={3000} className="radio radio-accent" />
//                                 <span>বার্ষিক ৩ হাজার টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={2000} className="radio radio-accent" />
//                                 <span>বার্ষিক ২ হাজার টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={1000} className="radio radio-accent" />
//                                 <span>মাসিক ১০০০ টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={500} className="radio radio-accent" />
//                                 <span>মাসিক ৫০০ টাকা</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="donation_type" value={300} className="radio radio-accent" />
//                                 <span>মাসিক ৩০০ টাকা</span>
//                             </label>
//                         </div> */}
//                         <div className="grid grid-cols-2 gap-2">
//                         {[
//                             { label: "বার্ষিক এক লক্ষ টাকা", value: 100000 },
//                             { label: "বার্ষিক ৫০ হাজার টাকা", value: 50000 },
//                             { label: "বার্ষিক ২৫ হাজার টাকা", value: 25000 },
//                             { label: "বার্ষিক ১৫ হাজার টাকা", value: 15000 },
//                             { label: "বার্ষিক ১০ হাজার টাকা", value: 10000 },
//                             { label: "বার্ষিক ৫ হাজার টাকা", value: 5000 },
//                             { label: "বার্ষিক ৩ হাজার টাকা", value: 3000 },
//                             { label: "বার্ষিক ২ হাজার টাকা", value: 2000 },
//                             { label: "মাসিক ১০০০ টাকা", value: 1000 },
//                             { label: "মাসিক ৫০০ টাকা", value: 500 },
//                             { label: "মাসিক ৩০০ টাকা", value: 300 },
//                             { label: "আপনার পছন্দ মত", value: 'custom' },
//                         ].map(({ label, value }) => (
//                             <label
//                                 key={value}
//                                 className="flex items-center space-x-2"
//                             >
//                                 <input
//                                     type="radio"
//                                     name="donation_type"
//                                     value={value}
//                                     checked={donationType === value.toString()}
//                                     onChange={() => setDonationType(value.toString())}
//                                     // disabled={isCustomAmount}
//                                     className="radio radio-accent"
//                                 />
//                                 <span>{label}</span>
//                             </label>
//                         ))}
//                     </div>
//                        {donationType === 'custom' && <><label class="label">
//                             <span class="label-text">অথবা আপনার ইচ্ছা মত পরিমাণ লিখুন</span>
//                         </label>

//                         <div className='grid grid-cols-2 gap-2'>
//                             <div>
//                                 <label className="form-control w-full max-w-xs">
//                                     <div className="label">
//                                         <span className="label-text">ধরন নির্বাচন করুন</span>
//                                     </div>
//                                     <select name='custom_donation_type' className="select select-bordered">
//                                         <option disabled selected>ধরন নির্বাচন</option>
//                                         <option>মাসিক</option>
//                                         <option>বাৎসরিক</option>
//                                     </select>
//                                 </label>
//                             </div>
//                             <div>
//                                 <label class="label">
//                                     <span class="label-text">অনুদানের পরিমাণ</span>
//                                 </label>
//                                 <input  name='custom_amount' type="number" placeholder="অনুদানের পরিমাণ" class="input input-bordered w-full max-w-xs" />
//                             </div>
//                         </div></>}
//                     </div>
//                     <div className="form-control w-80  border b-1 border-accent p-2">
//                         <label className="label">
//                             <span className="label-text">আপনার অনুদান কিভাবে পরিশোধ করতে ইচ্ছুক?</span>
//                         </label>
//                         <div className="grid grid-cols-1 gap-2 text-sm">
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="payment_type" value="handcash" className="radio radio-accent" />
//                                 <span>মাদ্‌রাসার অফিসে গিয়ে প্রদান করবো।</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="payment_type" value="bkash" className="radio radio-accent" />
//                                 <span>বিকাশ পারসোনাল (01758053022)</span>
//                             </label>
//                             <label className="flex items-center space-x-2">
//                                 <input type="radio" name="payment_type" value="bank" className="radio radio-accent" />
//                                 <span className='text-left'>হিসাব নংঃ- 26015124588 ডাচ বাংলা ব্যাংক, হাসনাবাদ শাখা।</span>
//                             </label>
//                         </div>
//                     </div>
//                     <div className="form-control w-80 text-left">
//                         <label className="label">
//                             <span className="label-text leading-5">আমি অত্র প্রতিষ্ঠানের লক্ষ্য, উদ্দেশ্য ও আদর্শের সাথে একাত্মতা পোষণ করি। এর উন্নতি-অগ্রগতির লক্ষ্যে, মহান আল্লাহ্ র সন্তুষ্টির নিয়তে 'আজীবন সদস্য' হিসেবে আজীবন আর্থিক খেদমত করেই যাবো---ইনশাআল্লাহ্। আমার প্রদানকৃত অর্থ কর্তৃপক্ষের বিবেচনা মোতাবেক প্রতিষ্ঠানের যেকোন খাতে, যেকোন বিভাগে ব্যয় করা যাবে।</span>
//                         </label>
//                         <div className="flex items-center space-x-2">
//                             <input
//                                 type="checkbox"
//                                 checked={isChecked}
//                                 onChange={handleCheckboxChange}
//                                 className="checkbox checkbox-accent"
//                             />
//                             <span>আমি সম্মত</span>
//                         </div>
//                     </div>

//                     <button disabled={!isChecked} className='btn btn-md btn-accent text-white my-4 rounded-md' type='submit'>ফর্ম জমা দিন</button>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default Members;



import React, { useState } from 'react';
import { toast } from 'react-toastify';

const Members = () => {
    const [isChecked, setIsChecked] = useState(false);
    const [donationType, setDonationType] = useState("");

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    const handleAddUser = (e) => {
        e.preventDefault();
        const form = e.currentTarget; // IMPORTANT FIX!

        const name = form.name.value;
        const mobile = form.mobile.value;
        const guardian_name = form.guardian_name.value;
        const age = form.age.value;
        const occupation = form.occupation.value;
        const medium_name = form.medium_name.value;
        const medium_phone = form.medium_phone.value;
        const fixed_village = form.fixed_village.value;
        const fixed_thana = form.fixed_thana.value;
        const fixed_district = form.fixed_district.value;
        const current_village = form.current_village.value;
        const current_thana = form.current_thana.value;
        const current_district = form.current_district.value;

        const donation_type = form.donation_type?.value;
        const custom_donation_type = form.custom_donation_type?.value;
        const custom_amount = form.custom_amount?.value;

        const payment_type = form.payment_type.value;

        const queryData = {
            name, mobile, guardian_name, age, occupation,
            medium_name, medium_phone,
            fixed_village, fixed_thana, fixed_district,
            current_village, current_thana, current_district,
            donation_type, custom_donation_type, custom_amount,
            payment_type
        };

        fetch('https://madrumi.thakurgaonexpress.com/members', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(queryData)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                form.reset(); // FIXED
                toast.success("আপনার আজীবন সদস্য ফর্ম পুরন সফল হয়েছে, ধন্যবাদ।");
            });

        // SMS API
        const token = `92310756091678413369ac9dc34ff7599524a6ea84a77094beb1`;
        const msg = `জনাব ${name}, আসসালামু আলাইকুম, মাদ্‌রাসা-এ জালালুদ্দীন রূমীর আজীবন দাতা সদস্য হওয়ার জন্য আপনাকে আন্তরিক মুবারকবাদ। প্রয়োজনে যোগাযোগ 01758053022`;
        const message = encodeURI(msg);
        const url = `https://api.greenweb.com.bd/api.php?token=${token}&to=${mobile}&message=${message}`;

        fetch(url)
            .then(res => res.json())
            .then(data => {
                console.log("SMS sent:", data);
            });
    };

    return (
        <div className='my-px pt-4'>
            <div className='leading-5'>
                <h1 className='text-2xl font-bold inline-block'> মাদ্‌রাসা-এ জালালুদ্দীন রূমী</h1> <br />
                <h1 className='text-xl font-bold inline-block'>খানকা চিশতিয়া এমদাদিয়া আশরাফিয়া</h1> <br />
                <h1 className='text-lg font-bold inline-block'>গুলশান-এ শাহ্‌ আব্দুল মতীন কমপ্লেক্স</h1> <br />
                <h1 className='text-md border-b-4 border-accent font-bold inline-block'>রূমী নগর, বড় জাফরপুর, কলাকোপা, নবাবগঞ্জ, ঢাকা।</h1>
                <br />
                <div className="flex justify-center items-center">
                <img className="my-4" src="mad.jpg" alt=""/>
                </div>
                <p className='text-justify mx-4 mt-4'>
                    <span className='font-bold'>মাদ্‌রাসা -এ জালালুদ্দীন রূমী এর</span> সার্বিক উন্নতি-অগ্রগতির সঙ্গী হতে আজীবন সদস্য হোন।
                </p>
            </div>

            <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>নতুন আজীবন দাতা সদস্য ফর্ম</h1>
            <hr />

            <div>
                <form onSubmit={handleAddUser} className='mt-8 flex justify-center items-center flex-col'>

                    

                    {/* Name */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">আপনার নাম *</span>
                        </label>
                        <input name='name' type="text" placeholder="আপনার নাম" className="input input-bordered w-full" required />
                    </div>

                    {/* Mobile */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">মোবাইল নম্বর *</span>
                        </label>
                        <input name='mobile' type="number" placeholder="মোবাইল নম্বর" className="input input-bordered w-full" required />
                    </div>

                    {/* Guardian name */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">পিতা/স্বামীর নাম</span>
                        </label>
                        <input name='guardian_name' type="text" placeholder="পিতা/স্বামীর নাম" className="input input-bordered w-full" />
                    </div>

                    {/* Age */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">বয়স</span>
                        </label>
                        <input name='age' type="text" placeholder="আপনার বয়স" className="input input-bordered w-full" />
                    </div>

                    {/* Occupation */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">পেশা</span>
                        </label>
                        <input name='occupation' type="text" placeholder="আপনার পেশা" className="input input-bordered w-full" />
                    </div>

                    {/* Medium */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">আপনি কার মাধ্যমে সদস্য হচ্ছেন?</span>
                        </label>
                        <input name='medium_name' type="text" placeholder="মাধ্যমের নাম" className="input input-bordered w-full" />
                        <input name='medium_phone' type="text" placeholder="মোবাইল নম্বর" className="input input-bordered w-full" />
                    </div>

                    {/* Permanent Address */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">স্থায়ী ঠিকানা</span>
                        </label>
                        <input name='fixed_village' type="text" placeholder="গ্রাম/ওয়ার্ড" className="input input-bordered w-full" />
                        <input name='fixed_thana' type="text" placeholder="থানা" className="input input-bordered w-full" />
                        <input name='fixed_district' type="text" placeholder="জেলা" className="input input-bordered w-full" />
                    </div>

                    {/* Current Address */}
                    <div className="form-control w-80">
                        <label className="label">
                            <span className="label-text">বর্তমান ঠিকানা</span>
                        </label>
                        <input name='current_village' type="text" placeholder="গ্রাম/ওয়ার্ড" className="input input-bordered w-full" />
                        <input name='current_thana' type="text" placeholder="থানা" className="input input-bordered w-full" />
                        <input name='current_district' type="text" placeholder="জেলা" className="input input-bordered w-full" />
                    </div>

                    {/* Donation Type */}
                    <div className="form-control w-80 text-xs border border-accent p-2 my-2">
                        <label className="label">
                            <span className="label-text">অনুদানের ধরন নির্বাচন করুন</span>
                        </label>

                        <div className="grid grid-cols-2 gap-2">
                            {[
                                { label: "বার্ষিক এক লক্ষ টাকা", value: 100000 },
                                { label: "বার্ষিক ৫০ হাজার টাকা", value: 50000 },
                                { label: "বার্ষিক ২৫ হাজার টাকা", value: 25000 },
                                { label: "বার্ষিক ১৫ হাজার টাকা", value: 15000 },
                                { label: "বার্ষিক ১০ হাজার টাকা", value: 10000 },
                                { label: "বার্ষিক ৫ হাজার টাকা", value: 5000 },
                                { label: "বার্ষিক ৩ হাজার টাকা", value: 3000 },
                                { label: "বার্ষিক ২ হাজার টাকা", value: 2000 },
                                { label: "মাসিক ১০০০ টাকা", value: 1000 },
                                { label: "মাসিক ৫০০ টাকা", value: 500 },
                                { label: "মাসিক ৩০০ টাকা", value: 300 },
                                { label: "আপনার পছন্দ মত", value: 'custom' },
                            ].map(({ label, value }) => (
                                <label key={value} className="flex items-center space-x-2">
                                    <input
                                        type="radio"
                                        name="donation_type"
                                        value={value}
                                        checked={donationType === value.toString()}
                                        onChange={() => setDonationType(value.toString())}
                                        className="radio radio-accent"
                                    />
                                    <span>{label}</span>
                                </label>
                            ))}
                        </div>

                        {/* Custom Donation */}
                        {donationType === 'custom' && (
                            <>
                                <label className="label">
                                    <span className="label-text">অথবা আপনার ইচ্ছা মত পরিমাণ লিখুন</span>
                                </label>

                                <div className='grid grid-cols-2 gap-2'>
                                    <div>
                                        <label className="form-control w-full">
                                            <div className="label">
                                                <span className="label-text">ধরন নির্বাচন করুন</span>
                                            </div>
                                            <select name='custom_donation_type' className="select select-bordered">
                                                <option disabled selected>ধরন নির্বাচন</option>
                                                <option>মাসিক</option>
                                                <option>বাৎসরিক</option>
                                            </select>
                                        </label>
                                    </div>

                                    <div>
                                        <label className="label">
                                            <span className="label-text">অনুদানের পরিমাণ</span>
                                        </label>
                                        <input name='custom_amount' type="number" placeholder="অনুদানের পরিমাণ" className="input input-bordered w-full" />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Payment Type */}
                    <div className="form-control w-80 border border-accent p-2">
                        <label className="label">
                            <span className="label-text">অনুদান পরিশোধ করবেন কিভাবে?</span>
                        </label>
                        <div className="grid grid-cols-1 gap-2 text-sm">
                            <label className="flex items-center space-x-2">
                                <input type="radio" name="payment_type" value="handcash" className="radio radio-accent" />
                                <span>মাদ্‌রাসার অফিসে গিয়ে প্রদান করবো।</span>
                            </label>
                            <label className="flex items-center space-x-2">
                                <input type="radio" name="payment_type" value="bkash" className="radio radio-accent" />
                                <span>বিকাশ পারসোনাল (01758053022)</span>
                            </label>
                            <label className="flex items-center space-x-2">
                                <input type="radio" name="payment_type" value="bank" className="radio radio-accent" />
                                <span>হিসাবের নামঃ Madrasa-E Jalaluddin Rumi, হিসাব নংঃ 1301100132333,  ডাচ বাংলা ব্যাংক পিএলসি, জয়পারা শাখা, দোহার, ঢাকা।</span>
                            </label>
                        </div>
                    </div>

                    {/* Agreement */}
                    <div className="form-control w-80 text-left">
                        <label className="label">
                            <span className="label-text leading-5">
                                আমি অত্র প্রতিষ্ঠানের লক্ষ্য, উদ্দেশ্য ও আদর্শের সাথে একাত্মতা পোষণ করি...
                            </span>
                        </label>
                        <div className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                className="checkbox checkbox-accent"
                            />
                            <span>আমি সম্মত</span>
                        </div>
                    </div>

                    {/* Submit */}
                    <button
                        disabled={!isChecked}
                        className='btn btn-md btn-accent text-white my-4 rounded-md'
                        type='submit'
                    >
                        ফর্ম জমা দিন
                    </button>

                </form>
            </div>
        </div>
    );
};

export default Members;
